export default class ViewTeacherAccountController {
    // @ngInject
    constructor(targetUser, schoolId) {
        this.targetUser = targetUser;
        this.schoolId = schoolId;
    }
}
